import EstoqueVariacaoService from "@/services/EstoqueVariacaoService";

export const estoqueVariacao = {
  namespaced: true,
  state: {
    estoqueVariacao: {},
  },
  actions: {
    getEstoqueVariacao({ commit }, payload) {
      return EstoqueVariacaoService.GetEstoqueVariacao(payload).then(
        (estoqueVariacao) => {
          return Promise.resolve(estoqueVariacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEstoqueVariacao({ commit }, payload) {
      return EstoqueVariacaoService.PostEstoqueVariacao(payload).then(
        (estoqueVariacao) => {
          return Promise.resolve(estoqueVariacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEstoqueVariacao({ commit }, payload) {
      return EstoqueVariacaoService.PutEstoqueVariacao(payload).then(
        (estoqueVariacao) => {
          return Promise.resolve(estoqueVariacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteEstoqueVariacao({ commit }, payload) {
      return EstoqueVariacaoService.DeleteEstoqueVariacao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEstoqueVariacaoOData({ commit }, payload) {
      return EstoqueVariacaoService.GetEstoqueVariacaoOData(payload).then(
        (estoqueVariacao) => {
          return Promise.resolve(estoqueVariacao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default estoqueVariacao;
